import { Navigate, useRoutes } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { issuerRoutes, companyIssuerRoutes } from './index'

const IssuerRoutesWrapper = () => {
  const { user } = useAuth();
  const isCompanyIssuer = !!user?.CreatedByIssuerID;
  const routesToUse = isCompanyIssuer ? companyIssuerRoutes : issuerRoutes;

  return useRoutes(routesToUse);
};

export default IssuerRoutesWrapper;
